import styled from 'styled-components';

import { ReactComponent as Check } from 'assets/icons/interface.svg';
import { ReactComponent as Error } from 'assets/icons/signs.svg';
import { device } from 'config/device';

export const CheckIcon = styled(Check)`
  height: 8rem;
  width: 8rem;
  border-radius: 50%;
  padding: 1.5rem;
  border: 2px solid ${({ theme }) => theme.green};
  fill: ${({ theme }) => theme.green};
`;
export const ErrorIcon = styled(Error)`
  height: 8rem;
  width: 8rem;
  border-radius: 50%;
  padding: 1.5rem;
  border: 2px solid ${({ theme }) => theme.error};
  fill: ${({ theme }) => theme.error};
`;

export const FinalScreenContainer = styled.div`
  border-radius: 8px;
  height: 100%;
  margin: 4rem auto;
  display: flex;
  background-color: #ffffff;
  box-shadow: ${(props) => props.theme.shadow[3]};
  @media ${device.tablet} {
    flex-direction: column-reverse;
  }

  .errorMessage {
    font-size: 18px;
  }
`;

export const InfoWrapper = styled.div`
  width: 100%;
  gap: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 3rem;
  overflow: hidden;
  @media ${device.tablet} {
    flex: 1;
  }
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .wrapper {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  span,
  p {
    margin-top: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.gray3};
  }
  p {
    width: 100%;
    word-wrap: break-word;
    margin-bottom: 4rem;
  }
  span {
    font-size: ${(props) => props.theme.large};
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4rem;
  align-items: center;

  h3 {
    margin-top: 2rem;
  }
  .buttons {
    margin-top: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    grid-gap: 1rem;
    flex-wrap: wrap;
  }
`;
export const ImageWrapper = styled.div`
  min-width: 40%;
  background-color: #ededed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media ${device.tablet} {
    min-height: 20rem;
  }

  &.errorTypeWrapper {
    display: flex;
    align-items: center;

    div {
      width: 150px !important;
    }
  }
`;

export const StyledButton = styled.button`
  padding: 1.5rem 4rem;
  border-radius: 25px;
  background-color: ${({ theme }) => theme.special};
  color: #fff;
  font-weight: bold;
  outline: none;
  border: none;
  cursor: pointer;
  margin-top: auto;
  :hover {
    opacity: 0.9;
  }
`;
